import React, { useState, cloneElement, isValidElement } from 'react';
import clsx from 'clsx';
import {
  Container,
  MobileSlider,
  PanelContent,
  WebLayout,
  WebLeftPanel,
  WebRightPanel,
} from './styles';

/**
 * A responsive split panel component with smooth transitions.
 * - Mobile: Slides between left and right panels (one at a time)
 * - Web: Shows left panel full width, or both panels 50/50 split
 */

let setActiveTabExternal;

export const onNavigateRight = () => {
  if (setActiveTabExternal) setActiveTabExternal(1);
};

export const onNavigateLeft = () => {
  if (setActiveTabExternal) setActiveTabExternal(0);
};

const FlexibleLayout = (props) => {
  const { leftPanel, rightPanel, showRightPanel, defaultRightPanel = null, handleLeftPanelClose, handleRightPanelClose } = props;

  const [, setActiveTab] = useState(0);
  const [highlightedElement, setHighlightedElement] = useState(props.highlightedElement);

  setActiveTabExternal = setActiveTab;

  const onLeftPanelClose = () => {
    handleLeftPanelClose?.();
  };

  const onRightPanelClose = () => {
    setActiveTab(0);
    setHighlightedElement(null);
    handleRightPanelClose?.();
  };

  const withPanelProps = (panel) => {
    return isValidElement(panel)
      ? cloneElement(panel, {
          highlightedElement,
          setHighlightedElement,
          onRightPanelClose,
          onLeftPanelClose,
        })
      : null;
  };

  // Web Layout
  return (
    <Container>
      <WebLayout>
        <MobileSlider className={clsx(showRightPanel && 'showRight')}>
          {/* Left Panel */}
          <WebLeftPanel className={clsx(showRightPanel && 'split')}>
            <PanelContent>{withPanelProps(leftPanel)}</PanelContent>
          </WebLeftPanel>

          {/* Right Panel */}
          <WebRightPanel className={clsx(showRightPanel && 'visible')}>
            <PanelContent>{showRightPanel && withPanelProps(rightPanel ?? defaultRightPanel)}</PanelContent>
          </WebRightPanel>
        </MobileSlider>
      </WebLayout>
    </Container>
  );
};

export default FlexibleLayout;
